import { useState, useEffect } from 'react';
import api from '../services/api';

interface GuineaContextStats {
  rural_patients_percentage: number;
  avg_travel_distance: number;
  mobile_money_usage: number;
  cnss_patients: number;
  regional_distribution: Array<{
    region_name: string;
    patient_count: number;
    total_revenue: number;
    avg_distance_km: number;
  }>;
  guinea_payment_methods: Array<{
    method_name: string;
    amount: number;
    usage_percentage: number;
  }>;
  socioeconomic_impact: Array<{
    month: string;
    local_economy: number;
    employment_impact: number;
    community_health_score: number;
  }>;
  accessibility_analysis: Array<{
    distance_km: number;
    visit_frequency: number;
    region: string;
  }>;
  jobs_created: number;
  staff_trained: number;
  local_partnerships: number;
  community_impact_score: number;
  insurance_coverage_rate: number;
  underserved_regions: number;
  training_potential: number;
}

export function useGuineaContextStats(dateRange: { start_date?: string; end_date?: string }) {
  const [data, setData] = useState<GuineaContextStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await api.get('/dashboard/guinea-context-stats/', {
          params: dateRange
        });
        setData(response.data);
        setError(null);
      } catch (err) {
        setError('Erreur lors du chargement des statistiques contextuelles');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dateRange.start_date, dateRange.end_date]);

  return { data, isLoading, error };
}